var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("entity-filter", {
        staticClass: "mb-n1",
        attrs: {
          isLoading: _vm.isLoading,
          useEvents: "",
          teams: _vm.teams,
          "start-with-default-team": ""
        },
        on: { change: _vm.filterChange }
      }),
      _vm.selectedEvent
        ? _c("event-time-table", {
            attrs: {
              event: _vm.event,
              "slot-data": _vm.filteredEncounters,
              "monster-slots": _vm.monsterSlots,
              "place-holders": _vm.placeHolders,
              "show-monster-slots": true,
              "read-route-name": "readEncounter"
            },
            on: { slotSelected: _vm.handleSlotSelected }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }